import { render, staticRenderFns } from "./EditPeopleCounterAnalytics.vue?vue&type=template&id=08b3c260"
import script from "./EditPeopleCounterAnalytics.vue?vue&type=script&lang=js"
export * from "./EditPeopleCounterAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports